import { render, staticRenderFns } from "./JokerIcon.vue?vue&type=template&id=bb8fec38&"
import script from "./JokerIcon.vue?vue&type=script&lang=js&"
export * from "./JokerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports